"use strict";
define('components/download',[], function() {
    /*
     * Component used to manage download links.  Shows a 'waiting' modal and triggers the
     * download.  The modal is hidden on download.
     */
    return function(downloadBtn) {
        var waitingModal = $('#waiting-modal');
        if (waitingModal.length == 0) {
            return;
        }

        waitingModal.find('.modal-title>span').text(downloadBtn.data('waiting-modal-title'));
        waitingModal.find('.modal-body').text(downloadBtn.data('waiting-modal-body'));
        waitingModal.modal('show');

        var startDownloadUrl = downloadBtn.data('url') || downloadBtn.attr('href');
        if (startDownloadUrl) {
            require('components/ajax')(
                startDownloadUrl,
                {
                    onSuccess: function(result) {
                        waitingModal.modal('hide');
                        window.location = result.download_url;
                    },
                    onFailure:function(result) {
                        waitingModal.find('.modal-body').text('');
                        waitingModal.modal('hide');
                    },
                    onError:function(result) {
                        waitingModal.find('.modal-body').text('');
                        waitingModal.modal('hide');
                    }
                }
            );
        }
    };

});   

